import create from "zustand";

const useBenefitsStore = create((set) => ({
    benefits: [],
    filteredBenefits: [],
    categories: [],

    setData: (payload) => {
        const benefits = payload.data;
        const categories = getUniqueCategories(benefits);
        set({ benefits: benefits, filteredBenefits: benefits, categories });
    },

    filterBenefits: (payload) => {
        set((state) => {
            if (payload.name == "Todos") {
                return {
                    filteredBenefits: state.benefits,
                };
            } else {
                return {
                    filteredBenefits: state.benefits.filter(
                        (benefit) => benefit.category.name == payload.name
                    ),
                };
            }
        });
    },
}));

export default useBenefitsStore;

const getUniqueCategories = (data) => {
    const uniqueCategories = data.reduce((acc, benefit) => {
        if (acc.some((x) => x.name === benefit.category.name)) {
            acc.find((x) => x.name === benefit.category.name).amount++;
            return acc;
        }
        return [
            ...acc,
            {
                id: acc.length + 1,
                name: benefit.category.name,
                sortOrder: benefit.category.sort_order,
                amount: 1,
            },
        ];
    }, []);

    return uniqueCategories.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
    });
};
